/* eslint-disable no-unused-vars */
/* eslint-disable react/require-default-props */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import {
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Snackbar,
  IconButton,
  Alert,
} from '@mui/material';

import CloseIcon from '@mui/icons-material/Close';
import QrCode2Icon from '@mui/icons-material/QrCode2';
import IosShareIcon from '@mui/icons-material/IosShare';
import { tokens } from '../../../tokens';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

function BootstrapDialogTitle(props) {
  const { children, onShare, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onShare ? (
        <IconButton
          aria-label="share"
          onClick={onShare}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: tokens.token_text_grey_on_white,
          }}
        >
          <IosShareIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
}

BootstrapDialogTitle.propTypes = {
  children: PropTypes.node,
  onShare: PropTypes.func.isRequired,
};

const roomAddress = '1Fw7wvVPhv5eioWQZ2if2zRUcHNdNBfu9r';

export default function URoomQRCode({ roomLink }) {
  const [open, setOpen] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('info');

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const handleShare = async () => {
    if (navigator.share) {
      try {
        await navigator.share({
          title: 'Room QR Code',
          text: 'Scan this QR code to join the room:',
          url: `${roomLink}`,
          // url: `https://api.qrserver.com/v1/create-qr-code/?size=250x250&data=${roomAddress}`,
        });

        setSnackbarMessage('QR code shared successfully!');
        setSnackbarSeverity('success');
      } catch (err) {
        setSnackbarMessage('Error sharing QR code');
        setSnackbarSeverity('error');
      }
    } else {
      setSnackbarMessage('Sharing not supported in this browser');
      setSnackbarSeverity('warning');
    }

    setSnackbarOpen(true);
  };

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  return (
    <div>
      <IconButton
        aria-controls="menu"
        aria-haspopup="true"
        onClick={handleClickOpen}
        sx={{
          color: tokens.palette_primary,
          margin: '4px',
          '&.MuiButtonBase-root.MuiIconButton-root:hover': {
            borderRadius: '8px',
            padding: '8px',
            backgroundColor: tokens.token_hairline,
          },
        }}
      >
        <QrCode2Icon sx={{ color: tokens.palette_primary }} />
      </IconButton>
      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
      >
        <BootstrapDialogTitle
          id="customized-dialog-title"
          onShare={handleShare}
        >
          Room QR Code
        </BootstrapDialogTitle>
        <DialogContent dividers>
          {/* <Box sx={{ display: 'flex', justifyContent: 'center' }}> */}
          <Box
            sx={{
              border: `1px solid ${tokens.token_hairline}`,
              backgroundColor: tokens.token_surface,
              borderRadius: '8px',
            }}
          >
            <img
              alt="address-QR-code"
              layout="responsive"
              style={{
                maxHeight: '250px',
                height: '100%',
                maxWidth: '250px',
                width: '100%',
                padding: '8px',
              }}
              src={`https://api.qrserver.com/v1/create-qr-code/?size=250x250&data=${roomLink}`}
            />
          </Box>
          {/* </Box> */}
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={handleClose}>
            Dismiss
          </Button>
        </DialogActions>
      </BootstrapDialog>
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity={snackbarSeverity}
          sx={{ width: '100%' }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </div>
  );
}